import { gofor } from '@fiverr-private/futile/lib/gofor';
import pathfinder from '@fiverr-private/pathfinder';
import { EVENTS_MAPPING } from '../utils/constants';
import { PATHFINDER } from '../config/filters';
import metricsService from '../../../shared/service/metrics';
import tracker from './tracker';

export const fetchRelatedSearchTerms = (fetchUrl) => (
    gofor(fetchUrl)
        .then((response) => response.ok ? response.json() : {})
        .then(({ related_search_terms = [] }) => {
            if (related_search_terms.length > 0) {
                metricsService.count('related_search_terms.viewed');
                tracker.track(EVENTS_MAPPING.VIEWED_RELATED_SEARCH_TERMS, { 'Number of Related Terms Viewed': related_search_terms.length });
            }

            return related_search_terms.map((term) => {

                const { query, pos } = term;

                const termUrl = pathfinder(PATHFINDER.SEARCH, null, { query: { ...term, source: 'related_search_terms' } });

                return { query, pos, termUrl };
            });
        })
);

export const trackClick = () =>
    metricsService.count('related_search_terms.clicked');
